import styled from 'styled-components';
import { TextButton as Button } from '@oneaudi/unified-web-components';
import { COLORS } from '../../../styles/variables';

export const ZipInputWrapper = styled.form`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 0px 16px 24px;
  gap: 16px;
  border-bottom: 1px solid ${COLORS.grey15};
`;
export const InputComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 245px;
`;
export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${COLORS.grey80};
  align-items: center;
  padding-bottom: 8px;
  position: relative;
`;
export const Description = styled.div`
  padding-top: 12px;
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${COLORS.grey60};
`;
export const TextInputField = styled.input`
  width: 100% !important;
  all: unset;
  padding-left: 12px;
  position: relative;
  padding-top: 4px;
  height: 24px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  outline: none;
  box-sizing: unset !important;

  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  }
  :-moz-placeholder {
    color: transparent !important;
  }
  :-moz-placeholder:focus {
    color: #555 !important;
  }
`;

export const BackToNational = styled.button`
  background-color: inherit;
  padding: 0;
  padding-top: 12px;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${COLORS.grey60};
  cursor: pointer;
`;

export const ChevronIcon = styled.div`
  width: 24px;
  height: 24px;
`;

export const SubmitButton = styled.button`
  font-size: 16px;
  letter-spacing: 0.002px;
  line-height: 20px;
  padding: 14px 16px;
  border: 1px solid ${COLORS.black};
  background-color: inherit;
  cursor: pointer;
`;

export const DeleteInputIcon = styled.button`
  padding: 0;
  background-color: inherit;
  border: none;
  position: absolute;
  right: 0;
  bottom: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const StyledCTA = styled(Button)`
  width: auto;
  min-width: fit-content;
  span {
    font-stretch: unset;
  }
`;
